import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useMenusActions } from '../../states/menus/menu.actions';
import { IConteudo, IMenu, ISecao } from '../../commons/types/base';
import { Grid2, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { findBreadcrumb } from '../../components/Breadcrumb/findBreadcrumb';
import type { IMenuItens } from '../../components/Header';
import Eventos from '../Eventos';
import { GridBackground, TypographyDesc } from '../Acoes';
import Consultor from '../Home/Components/Consultor';
import Breadcrumb from '../../components/Breadcrumb';
import { Box } from '@mui/material';
import { useTranslation } from '../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';
import { useDateFormatters } from '../../utils/useDateFormatters';

function createHTMLFromString(htmlString: any) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}

interface IParams {
  id?: string;
}

const SecaoComponent: React.FC = () => {
  const { language, translate } = useTranslation();
  const { formatarData } = useDateFormatters();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  
  const path = window.location.pathname;
  const { id } = useParams<IParams>();
  const [conteudos, setConteudos] = useState<IConteudo[]>([]);
  const [secao, setSecao] = useState<ISecao>();
  const location = useLocation();
  const currentPath = location.pathname;
  const [isEvento, setIsEvento] = useState<boolean>(false);

  const menusActions = useMenusActions();

  useEffect(() => {
    const loadData = async () => {
      let structure = JSON.parse(localStorage.getItem('menusDinamicos') ?? '[]') as IMenuItens[];
      const breadcrumb = findBreadcrumb(currentPath, structure);
      const indexEventos = breadcrumb!.findIndex((f: any) => f.nome === 'Eventos');
      if (indexEventos >= 0 && indexEventos < breadcrumb!.length - 1) {
        setIsEvento(true);
      } else {
        setIsEvento(false);
      }
    }
    loadData();
    menusActions
      .get()
      .then((d) => {
        let menus: IMenu = d.resultado;

        const secao = menus.secoes.find((f) => f.id == Number(id));
        const area = menus.areas.find((f) => f.id == secao?.idArea!);
        const conteudos = menus.conteudos.filter(
          (f) =>
            f.idSecaos!.findIndex((f) => f.id == Number(id)) >= 0 &&
            f.idAreas!.findIndex((f) => f.id == area?.id) >= 0,
        );
        setSecao(secao);
        setConteudos(conteudos);
      })
      .catch((erro) => {
      });
  }, [id]);

  return (
    <>
      {isEvento ? <Eventos /> :
        <GridBackground container direction="column" spacing={0} sx={{ minHeight: '90vh' }}>
          <Consultor />

          <Grid2 size={{ xs: 12 }}>
            <Breadcrumb />
          </Grid2>

          <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '30px' }}>
            <Typography variant="h1">{secao?.nome}</Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '10px', width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
            <TypographyDesc variant="body1" sx={{
              '& img': {
                maxWidth: '100%',
                height: 'auto'
              },
              '& table': {
                maxWidth: '100%',
                display: 'block',
                overflowX: 'auto'
              }
            }}>
              <Box sx={{ 
                width: '100%',
                maxWidth: '100%',
                overflowX: 'auto'
              }}>
                {createHTMLFromString(secao?.descricao)}
              </Box>
            </TypographyDesc>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            {conteudos.map((item: IConteudo) => {
              return (
                <>
                  <Grid container xs={12} md={12} sx={{ paddingBottom: '10px', display: 'flex' }}>
                    <Grid
                      container
                      xs={12}
                      md={12}
                      sx={{
                        paddingBottom: '10px',
                        display: 'flex',
                        borderBottom: 'solid 1.5px #dfdfdf',
                      }}
                    >
                      {item?.anexo && (
                        <>
                          <Grid
                            sx={{ display: 'flex', padding: '20px 10px' }}
                          >
                            <img
                              src={item?.anexo}
                              alt="imagem"
                              style={{ maxWidth: '200px', width: '150px', borderRadius: '10px' }}
                            />
                          </Grid>
                        </>
                      )}

                      <Grid container xs={10} md={10} sx={{ display: 'flex', padding: '20px 10px' }}>
                        <Link 
                          to={path + '/conteudos/' + item.id}
                          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                          {item.titulo}
                        </Link>
                        {item.dtPublicacao && (
                          <Grid container xs={12} md={12} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <IconButton
                              sx={{
                                display: 'flex',
                                alignContent: 'center',
                                flexWrap: 'wrap',
                              }}
                            >
                              <CalendarMonthIcon
                                sx={{
                                  fontSize: '16px',
                                  color: '#551a8b',
                                }}
                              />
                            </IconButton>
                            <span
                              style={{
                                display: 'flex',
                                alignContent: 'center',
                                flexWrap: 'wrap',
                              }}
                            >
                              {formatarData(item.dtPublicacao)}
                            </span>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              );
            })}
          </Grid2>
        </GridBackground>
      }
    </>
  );
};

export default SecaoComponent;
